import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import React, { useState} from "react";
import axios from "axios";
import { api } from "./api/client";
import Grid from "@mui/material/Grid";
import {FormControlLabel, FormGroup} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

function formFromValues(values = {}) {
    return {
        ulke: values.ulke,
        sehir: values.sehir,
        lokasyon_adi: values.lokasyon_adi,
        yetkili: values.yetkili,
        telefon: values.telefon,
        eposta: values.eposta,
        yetkili_iki: values.yetkili_iki,
        telefon_iki: values.yetkili_iki_telefon,
        eposta_iki: values.yetkili_iki_eposta,
        yetkili_uc: values.yetkili_uc,
        telefon_uc: values.yetkili_uc_telefon,
        eposta_uc: values.yetkili_uc_eposta,
        yetkili_dort: values.yetkili_dort,
        telefon_dort: values.yetkili_dort_telefon,
        eposta_dort: values.yetkili_dort_eposta,
        yetkili_bes: values.yetkili_bes,
        telefon_bes: values.telefon_bes,
        eposta_bes: values.eposta_bes,
        yetkili_alti: values.yetkili_alti,
        telefon_alti: values.telefon_alti,
        eposta_alti: values.eposta_alti,
        yetkili_yedi: values.yetkili_yedi,
        telefon_yedi: values.telefon_yedi,
        eposta_yedi: values.eposta_yedi,
        yetkili_sekiz: values.yetkili_sekiz,
        telefon_sekiz: values.telefon_sekiz,
        eposta_sekiz: values.eposta_sekiz,
        yetkili_dokuz: values.yetkili_dokuz,
        telefon_dokuz: values.telefon_dokuz,
        eposta_dokuz: values.eposta_dokuz,
        adres: values.adres,
        lokasyon_id: values.lokasyon_id,
        musteriID: values.musteri_id,
    };
}

export default function ModalBoxEdit(props) {
    const [open, setOpen] = useState(false);
    const [state, setState] = useState(() => formFromValues(props.values));

    const handleChange = name => e => {
        setState({
            ...state,
            [name]: e.target.value
        });
        //console.log('state change',state);
    };

    const handleClickOpen = () => {
        setState(formFromValues(props.values));
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>
            <Button variant="contained" size={"small"} color="primary" onClick={handleClickOpen }>
                <EditIcon   />
            </Button>

            <Dialog
                maxWidth="lg"
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Lokasyon Düzenle</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    </DialogContentText>
                    <TextField
                        margin="dense"
                        id="ulke"
                        label="Ülke"
                        type="text"
                        value={state.ulke || ""}
                        onChange={handleChange("ulke")}
                    />
                    <TextField
                        margin="dense"
                        id="sehir"
                        label="Şehir"
                        type="text"
                        value={state.sehir || ""}
                        onChange={handleChange("sehir")}

                    />
                    <TextField
                        margin="dense"
                        id="lokasyon_adi"
                        label="Lokasyon Adı"
                        type="text"
                        value={state.lokasyon_adi || ""}
                        onChange={handleChange("lokasyon_adi")}
                    />


                    <TextField
                        margin="dense"
                        id="adres"
                        label="Adres"
                        type="tel"
                        value={state.adres || ""}
                        onChange={handleChange("adres")}
                        fullWidth
                        multiline
                    />

                    <Grid container rowSpacing={4} columnSpacing={{ xs: 5, sm: 2, md: 3 }}>
                        <Grid item xs={12}  >


                                <Grid item xs={12}>
                                    <TextField
                                        margin="dense"
                                        id="yetkili"
                                        label="Yetkili 1"
                                        type="tel"
                                        value={state.yetkili || ""}
                                        onChange={handleChange("yetkili")}

                                    />
                                    <TextField
                                    margin="dense"
                                    id="telefon"
                                    label="Telefon 1"
                                    type="tel"
                                    value={state.telefon || ""}
                                    onChange={handleChange("telefon")}

                                />
                                    <TextField
                                        margin="dense"
                                        id="email"
                                        label="Eposta 1"
                                        type="email"
                                        value={state.eposta || ""}
                                        onChange={handleChange("eposta")}

                                    />
                                </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="yetkili_iki"
                                    label="Yetkili 2"
                                    type="tel"
                                    value={state.yetkili_iki || ""}
                                    onChange={handleChange("yetkili_iki")}

                                />
                                <TextField
                                    margin="dense"
                                    id="telefon_iki"
                                    label="Telefon 2"
                                    type="tel"
                                    value={state.telefon_iki || ""}
                                    onChange={handleChange("telefon_iki")}

                                />
                                <TextField
                                    margin="dense"
                                    id="email_iki"
                                    label="Eposta 2"
                                    type="email"
                                    value={state.eposta_iki || ""}
                                    onChange={handleChange("eposta_iki")}

                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="yetkili_uc"
                                    label="Yetkili 3"
                                    type="tel"
                                    value={state.yetkili_uc || ""}
                                    onChange={handleChange("yetkili_uc")}

                                />
                                <TextField
                                    margin="dense"
                                    id="telefon_uc"
                                    label="Telefon 3"
                                    type="tel"
                                    value={state.telefon_uc || ""}
                                    onChange={handleChange("telefon_uc")}

                                />
                                <TextField
                                    margin="dense"
                                    id="email_uc"
                                    label="Eposta 3"
                                    type="tel"
                                    value={state.eposta_uc || ""}
                                    onChange={handleChange("eposta_uc")}

                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="yetkili_dort"
                                    label="Yetkili 4"
                                    type="tel"
                                    value={state.yetkili_dort || ""}
                                    onChange={handleChange("yetkili_dort")}

                                />
                                <TextField
                                    margin="dense"
                                    id="telefon_dort"
                                    label="Telefon 4"
                                    type="tel"
                                    value={state.telefon_dort || ""}
                                    onChange={handleChange("telefon_dort")}

                                />
                                <TextField
                                    margin="dense"
                                    id="email_dort"
                                    label="Eposta 4"
                                    type="tel"
                                    value={state.eposta_dort || ""}
                                    onChange={handleChange("eposta_dort")}

                                />
                        </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="yetkili_bes"
                                    label="Yetkili 5"
                                    type="tel"
                                    value={state.yetkili_bes || ""}
                                    onChange={handleChange("yetkili_bes")}

                                />
                                <TextField
                                    margin="dense"
                                    id="telefon_bes"
                                    label="Telefon 5"
                                    type="tel"
                                    value={state.telefon_bes || ""}
                                    onChange={handleChange("telefon_bes")}

                                />
                                <TextField
                                    margin="dense"
                                    id="email_bes"
                                    label="Eposta 5"
                                    type="tel"
                                    value={state.eposta_bes || ""}
                                    onChange={handleChange("eposta_bes")}

                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="yetkili_alti"
                                    label="Yetkili 6"
                                    type="tel"
                                    value={state.yetkili_alti || ""}
                                    onChange={handleChange("yetkili_alti")}

                                />
                                <TextField
                                    margin="dense"
                                    id="telefon_alti"
                                    label="Telefon 6"
                                    type="tel"
                                    value={state.telefon_alti || ""}
                                    onChange={handleChange("telefon_alti")}

                                />
                                <TextField
                                    margin="dense"
                                    id="email_alti"
                                    label="Eposta 6"
                                    type="tel"
                                    value={state.eposta_alti || ""}
                                    onChange={handleChange("eposta_alti")}

                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="yetkili_yedi"
                                    label="Yetkili 7"
                                    type="tel"
                                    value={state.yetkili_yedi || ""}
                                    onChange={handleChange("yetkili_yedi")}

                                />
                                <TextField
                                    margin="dense"
                                    id="telefon_yedi"
                                    label="Telefon 7"
                                    type="tel"
                                    value={state.telefon_yedi || ""}
                                    onChange={handleChange("telefon_yedi")}

                                />
                                <TextField
                                    margin="dense"
                                    id="email_yedi"
                                    label="Eposta 7"
                                    type="tel"
                                    value={state.eposta_yedi || ""}
                                    onChange={handleChange("eposta_yedi")}

                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="yetkili_sekiz"
                                    label="Yetkili 8"
                                    type="tel"
                                    value={state.yetkili_sekiz || ""}
                                    onChange={handleChange("yetkili_sekiz")}

                                />
                                <TextField
                                    margin="dense"
                                    id="telefon_sekiz"
                                    label="Telefon 8"
                                    type="tel"
                                    value={state.telefon_sekiz || ""}
                                    onChange={handleChange("telefon_sekiz")}

                                />
                                <TextField
                                    margin="dense"
                                    id="email_sekiz"
                                    label="Eposta 8"
                                    type="tel"
                                    value={state.eposta_sekiz || ""}
                                    onChange={handleChange("eposta_sekiz")}

                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    margin="dense"
                                    id="yetkili_dokuz"
                                    label="Yetkili 9"
                                    type="tel"
                                    value={state.yetkili_dokuz || ""}
                                    onChange={handleChange("yetkili_dokuz")}

                                />
                                <TextField
                                    margin="dense"
                                    id="telefon_dokuz"
                                    label="Telefon 9"
                                    type="tel"
                                    value={state.telefon_dokuz || ""}
                                    onChange={handleChange("telefon_dokuz")}

                                />
                                <TextField
                                    margin="dense"
                                    id="email_dokuz"
                                    label="Eposta 9"
                                    type="tel"
                                    value={state.eposta_dokuz || ""}
                                    onChange={handleChange("eposta_dokuz")}

                                />
                            </Grid>
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        İptal
                    </Button>
                    <Button
                        onClick={

                            async () => {
                             await api.patch(`/lookups/lokasyonlar/${state.lokasyon_id}`, {

                                     'ulke': state.ulke,
                                     'sehir': state.sehir,
                                     'lokasyon_adi':state.lokasyon_adi,
                                     'telefon':state.telefon,
                                     'yetkili':state.yetkili,
                                     'eposta':state.eposta,
                                     'telefon_iki':state.telefon_iki,
                                     'yetkili_iki':state.yetkili_iki,
                                     'eposta_iki':state.eposta_iki,
                                     'telefon_uc':state.telefon_uc,
                                     'yetkili_uc':state.yetkili_uc,
                                     'eposta_uc':state.eposta_uc,
                                     'telefon_dort':state.telefon_dort,
                                     'yetkili_dort':state.yetkili_dort,
                                     'eposta_dort':state.eposta_dort,
                                 "yetkili_bes":state.yetkili_bes,
                                 "telefon_bes":state.telefon_bes,
                                 "eposta_bes":state.eposta_bes,
                                 "yetkili_alti":state.yetkili_alti,
                                 "telefon_alti":state.telefon_alti,
                                 "eposta_alti":state.eposta_alti,
                                 "yetkili_yedi":state.yetkili_yedi,
                                 "telefon_yedi":state.telefon_yedi,
                                 "eposta_yedi":state.eposta_yedi,
                                 "yetkili_sekiz":state.yetkili_sekiz,
                                  "telefon_sekiz":state.telefon_sekiz,
                                    "eposta_sekiz":state.eposta_sekiz,
                                    "yetkili_dokuz":state.yetkili_dokuz,
                                    "telefon_dokuz":state.telefon_dokuz,
                                    "eposta_dokuz":state.eposta_dokuz,
                                     'adres':state.adres,
                                     'musteri_id':state.musteriID,
                                     'lokasyon_id':state.lokasyon_id
                                 },
                        {
                            'ContentType': 'application/json'
                              })
                                .then((response) => {
                                    // Success 🎉
                                    console.log(response);
                                    props.locationChange(true);
                                    handleClose()
                                })
                                .catch((error) => {
                                    // Error 😨
                                    if (error.response) {
                                        /*
                                         * The request was made and the server responded with a
                                         * status code that falls out of the range of 2xx
                                         */
                                        console.log(error.response.data);
                                        console.log(error.response.status);
                                        console.log(error.response.headers);
                                    } else if (error.request) {
                                        /*
                                         * The request was made but no response was received, `error.request`
                                         * is an instance of XMLHttpRequest in the browser and an instance
                                         * of http.ClientRequest in Node.js
                                         */
                                        console.log(error.request);
                                    } else {
                                        // Something happened in setting up the request and triggered an Error
                                        console.log('Error', error.message);
                                    }
                                    console.log(error.config);
                                });
                        }}
                        color="primary"
                    >
                        Kaydet
                    </Button>
                </DialogActions>
            </Dialog></div>
    )
}

